// AI assisted development

/** Pendo application discriminator for cross-app analytics (UP-54793). */
export const PENDO_APPLICATION = 'CommandCenter';

/** Cross-app visitor identity field — same userId across Command Center, Admin, FormFactor. */
export const PENDO_VISITOR_ID_FIELD = 'userId';

/** Application metadata field name sent with every Pendo identify call. */
export const PENDO_APPLICATION_METADATA_FIELD = 'shopperkit_application';

/**
 * Visitor metadata fields allowed for SKit.CommandCenter (confirmed with PM / legal per UP-54793).
 * UP-54794 PendoService maps ContextInfo into these fields only.
 */
export const PENDO_VISITOR_METADATA_FIELDS: string[] = [
  'Full_Name',
  'Email',
  'Username',
  'AppSetLanguage',
];

/**
 * Account metadata fields allowed for SKit.CommandCenter.
 */
export const PENDO_ACCOUNT_METADATA_FIELDS: string[] = ['AccountId'];

/**
 * Visitor fields explicitly excluded from Pendo payloads (UP-54793 out of scope).
 */
export const PENDO_EXCLUDED_VISITOR_FIELDS: string[] = [
  'curbsideOnly',
  'canMessageCustomers',
  'enableDeliveryWorkflow',
];
